import { useCallback, useState } from 'react';

type CopiedValue = string | undefined;
type CopyFn = (text: string) => Promise<boolean>;

const useCopyToClipboard = (): { copiedText: CopiedValue; copyText: CopyFn } => {
    const [copiedText, setCopiedText] = useState<CopiedValue>(undefined);

    const copyText: CopyFn = useCallback(async text => {
        if (!navigator?.clipboard) {
            console.warn('Clipboard not supported');
            return false;
        }

        try {
            await navigator.clipboard.writeText(text);
            setCopiedText(text);
            return true;
        } catch (error) {
            console.warn('Copy failed', error);
            setCopiedText(undefined);
            return false;
        }
    }, []);

    return { copiedText, copyText };
};

export { useCopyToClipboard };
